import * as types from './mutation-types'
export default {
    [types.SET_USER_GUIDES](state, data) {
        state.userGuides = data
    },
    [types.SET_VIEW_USER_GUIDE](state, data) {
        state.viewUserGuide = data.id
    },
    [types.SET_TOTAL_USER_GUDIES](state, totalUserGuides) {
        state.totalUserGuides = totalUserGuides
    },
    
    [types.ADD_USER_GUIDE](state, data) {
        state.userGuides.push(data)
    },
    [types.UPDATE_USER_GUIDE](state, data) {
        let updateUserGuide = state.userGuides.findIndex(userGuide => userGuide.id === data.id)
        Object.assign(state.userGuides[updateUserGuide], { ...data })
    },
    [types.DELETE_USER_GUIDE](state, id) {
        let user_guides = state.userGuides.findIndex(user_guide => user_guide.id === id)
        state.userGuides.splice(user_guides, 1)
    },
    [types.DELETE_MULTIPLE_USER_GUIDES](state, selectedUserGuides) {
        selectedUserGuides.forEach((item) => {
            let index = state.userGuides.findIndex(_userguide => _userguide.id === _userguide.id)
            state.userGuides.splice(index, 1)
        })
        state.selectedUserGuides = []
    },
    [types.SET_SELECTED_USER_GUIDES](state, data) {
        state.selectedUserGuides = data
    },

    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
}